import React from 'react';
import PropTypes from 'prop-types';
import Framework from '@beardeddevops/react.framework';

class ImportList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			input: '',
			input_error: ''
		};
	}

	handleDataChange = (name, value) => {
		this.setState({
			'input': value,
			'input_error': ''
		})

	};

	handleSubmit() {
		this.props.afterSave(this.state.input);
	}

	render() {
		return (
			<div className="ImportList container">
				<div className="row">
					To bulk add Serial Numbers copy them from a spreadsheet, or separate them by a new line or comma.
				</div>
				<div className="row">
					<Framework.Elements.TextField
						property={{'name': 'input', ignore_validation: true}}
						value={this.state.input}
						error={this.state.input_error}
						update={this.handleDataChange}
						multiline={4}
						label=""
					/>
				</div>
			</div>
		);
	}
}

export default ImportList;
